import React from 'react';
import styled from 'styled-components/macro';

const TextInput = React.forwardRef(({ ...rest }, ref) => {
  return <Input ref={ref} {...rest} />;
});

export default TextInput;

const Input = styled.input`
  #certiself-form & {
    width: 100%;
    padding: 12px;
    margin: 6px 0 24px 0;
    border: 1px solid #ccc;
    background: #fafafa;
    color: #484848;
    font-family: sans-serif;
    font-size: 17px;
    line-height: normal;
    box-sizing: border-box;
    border-radius: 2px;

    &::placeholder {
      color: #b4b4b4;
    }

    &:disabled {
      color: #b4b4b4;
      background: #efefef;
    }

    &:focus {
      outline: none;
      position: relative;
    }
  }
`;
